<template>
    <div id="app" class="app fond">
        <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>
        <div v-for="compterendu in listeComptesRendusAnciens" :key="compterendu.id">
            <div class="fond-page" v-if="compterendu.id = listeDeliberationSelect">
                <section class="corps-texte">
                    <section class="en-tete-page">
                        <h1>{{Page.page}}</h1>
                        <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                    </section>

                    <h2 class="inter-titre" >Liste des délibérations du {{compterendu.date}}</h2>
                    <section class="Section-pages section-pages-cartes">
                        <div >
                            <h6 style="text-align: center;">{{compterendu.date}}</h6>
                            <div class="carte-conseiller">
                                <div>
                                    <iframe :src="compterendu.fichier_pdf" height="100%" width="100%"></iframe>
                                </div>
                            </div>
                        
                            <br>
                            <br>
                            <div class="button">
                                <a  :href="compterendu.fichier_pdf" target="_blank">Ouvrir le document</a>
                            </div>
                        </div>
                    </section>   
                    
                    <h3 class="inter-titre" style="text-align: left">Délibérations du {{compterendu.date}}</h3> 
                    <section class="Section-Page section-carte-scroll">
                        <div v-for="deliberation in listeDeliberations" :key="deliberation.id">
                            <div v-if="deliberation.liste_parente == compterendu.id">
                                <h6 style="text-align: center;">{{deliberation.titre}}</h6>
                                <div class="carte-conseiller">
                                    <iframe :src="deliberation.fichier_pdf" height="100%" width="100%"></iframe>
                                </div>
                                <br>
                                <br>
                                <div class="button">
                                    <a  :href="deliberation.fichier_pdf" target="_blank">Ouvrir le document</a>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'InfosMunicipales',
    data () {
        return{
            listeComptesRendusAnciens:[],
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            },
            listeDeliberations: [],
        }
    }, 

    created(){
        var currentdate = new Date();
        var date = new Date;
        var annee = date.getFullYear();
        var moi = date.getMonth();
        var mois = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
        var moisnumerique = new Array('01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12');

        var j = date.getDate();
        if(j < 10){
            j = '0'+j
        }
        var jour = date.getDay();
        var jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
        this.date = jours[jour]+' '+j+' '+mois[moi]+' '+annee+'';
        this.time = currentdate.getHours()+" h "+currentdate.getMinutes()+" min "+currentdate.getSeconds()+" sec";
        this.joursemaine = jours[jour];
        this.datejour = +j+'/'+moi;
        this.dateJourNum = j+'/'+moisnumerique[moi]+'/'+annee;
        this.DateMaxEN = annee+'-'+moisnumerique[moi]+'-'+j;
        this.jourInfini = mois[moi];
        this.dateAncienneNumUn = annee-1+'-'+moisnumerique[moi]+'-'+j;
        this.dateAncienneNumUnCompa =annee-1+moisnumerique[moi]+j;
        this.dateAncienneNum = annee-3+'-'+moisnumerique[moi]+'-'+j;
        this.dateFutureNum = this.anneeMoinsUn+'-'+moisnumerique[moi]+'-'+j;
        console.log(this.dateAncienneNum)

        this.dateMin = this.dateAncienneNum;
        this.dateMax = this.dateFutureNum

        this.listeDeliberationSelect = this.$route.params.id;



        axios.get(param.host+'listeDeliberations/v1/listeListeDeliberations')
        .then(response =>{
        this.listeComptesRendus = response.data;
            let CRM = new Array;
            let CRMRecent = new Array;
            var i = 0;
            var k = 0;

            for(var j = 0; this.listeComptesRendus.length > j; j++){
                this.dateSplitCRM = this.listeComptesRendus[j].date.split('/');
                this.listeComptesRendus[j].date_comparaison_crm = this.dateSplitCRM[2]+ this.dateSplitCRM[1]+ this.dateSplitCRM[0];

                this.listeComptesRendus[j].date = this.dateSplitCRM[1] +'/'+ this.dateSplitCRM[0]+'/'+ this.dateSplitCRM[2];

                if(this.listeComptesRendus[j].date_comparaison_crm < this.dateAncienneNumUnCompa){
                    CRM[i] = this.listeComptesRendus[j];
                    i++;
                }else{
                    CRMRecent[k] = this.listeComptesRendus[j];
                    k++;
                }

                this.listeComptesRendusAnciens = CRM;
                this.CRMRecents = CRMRecent;
            }
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Archives'){
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))

        axios.get(param.host+'deliberation/v1/listeDeliberations')
        .then(response => {
            this.listeDeliberations = response.data;
        })
        .catch(error => console.log(error))
    },

    computed:{
        CRCMOrderByDate: function(){
            
            function compare(a, b){
                if(a.date_comparaison_crm > b.date_comparaison_crm) return -1
                if(a.date_comparaison_crm < b.date_comparaison_crm) return 1
                return 0
            }
            if(this.listeComptesRendusAnciens != 'undefined'){
                return this.listeComptesRendusAnciens.sort(compare)
            }else{
                return this.listeComptesRendusAnciens = ''
            }
        },

        QIOrderByDate: function(){
            function compare(a, b){
                if(a.date_comparaison > b.date_comparaison) return -1
                if(a.date_comparaison < b.date_comparaison) return 1
                return 0
            }
            if(this.listeQI.length > 0){
                return this.listeQI.sort(compare)
            }else{
                return this.listeQI = ''
            }
        },

        EQNOrderByDate: function(){
            function compare(a, b){
                if(a.date_comparaison_crm > b.date_comparaison_crm) return -1
                if(a.date_comparaison_crm < b.date_comparaison_crm) return 1
                return 0
            }
            if(this.listeEchos.length > 0){
                return this.listeEchos.sort(compare)
            }else{
                return this.listeEchos = ''
            }
        },
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Liste-Deliberations.vue